import config from './config';

const checkout = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /**
       * If this is set to true then the shipping notification will be shown in checkout.
       */
      showShippingNotification: true,
      /**
       * This value controls “Use Shipping as Billing Address” checkbox to be
       * checked by default in checkout page.
       */
      useShippingAsBillingAddressAsDefault: true,
      /**
       * This value control whether there is a “order review” step in checkout
       * or if, after billing, the next step is order submission.
       */
      isCheckoutWithReviewStep: false,

      /** If shipping to US territories should be allowed. */
      allowShippingToUSTerritories: true,

      /** If shipping orders to PO Boxes should be allowed or not. */
      allowShippingToPOBoxes: true,

      /**
       * If this is set to false then international shipping is disabled from checkout.
       * The user will be unable to select a country outside of the current locale.
       */
      allowInternationalShipping: false,

      /**
       * Whether or not to display the 'Log in' message / link above shipping form fields.
       */
      showLoginMessage: true,

      /**
       * Payment methods to show in checkout.
       */
      paymentMethod: {
        /**
         * If this is set to false then the CREDIT CARD payment method will be disabled from checkout.
         */
        creditCard: true,

        /**
         * If this is set to false then the PAYPAL payment method will be disabled from checkout.
         */
        paypal: true,

        /**
         * Whether to show the Apple Pay payment method in the standard (non-express) checkout flow.
         * **Note**: This may be overridden by whether Apple Pay as a whole is enabled in the `applePay` config.
         */
        applePay: true,

        /**
         * If this is set to false then the GOOGLE PAY payment method will be disabled from checkout.
         */
        googlePay: false,

        /**
         * If this is set to false then the KLARNA payment method will be disabled from checkout.
         */
        klarna: false
      },

      /**
       * Whether to show the "Save Card to Account" checkbox during credit card checkout.
       * This allows authenticated users to save their payment information for future use.
       */
      showSaveCardToAccountCheckbox: false,
      /**
       * If this is set to true then the country information will be hidden from Shipping Summary in checkout page.
       */
      hideCountry: true,
      /**
       * Whether to allow user to manage their saved payments. If disabled, users only will
       * be able to add new cards for payments. It will be disabled in production until
       * [HP-5170](https://deckersbrand.atlassian.net/browse/HP-5170) is done.
       */
      allowSavedPaymentsManagement: false
    }
  },
  'AHNU-US': {
    default: {
      showShippingNotification: false,
      hideCountry: true,
      allowShippingToPOBoxes: false,
      allowShippingToUSTerritories: false
    }
  }
});

export default checkout;
